//格式化时间
function padLeftZero(str) {
  return ('00' + str).substr(str.length);
};
export function formatDateTime(time, fmt) {
  if (time == null || time == '' || time == undefined) {
    return;
  }
  let date = new Date(time);

  // 格式默认  年-月-日
  if (fmt == null || fmt == '' || fmt == undefined) {
    // fmt = 'yyyy-MM-dd hh:mm:ss'
    fmt = 'yyyy-MM-dd'
  }

  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  };
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + '';
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
    }
  }
  return fmt;
};
// 下载base64的文件
function downloadFile(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename; // 必须带正确扩展名！
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
export function downloadFromBase64(base64, mimeType, filename) {
  const byteString = atob(base64);
  const byteArray = new Uint8Array(byteString.split('').map(c => c.charCodeAt(0)));
  const blob = new Blob([byteArray], { type: mimeType });
  downloadFile(blob, filename);
}
export function copyText(text) {
  // 现代 API（HTTPS / localhost）
  if (navigator.clipboard && window.isSecureContext) {
    return navigator.clipboard.writeText(text);
  }

  // 降级方案（HTTP 也支持）
  return new Promise((resolve, reject) => {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    try {
      if (document.execCommand('copy')) {
        resolve();
      } else {
        reject(new Error('execCommand copy failed'));
      }
    } catch (err) {
      reject(err);
    } finally {
      document.body.removeChild(textarea);
    }
  });
}